
import HolidayIndex from '../components/holidays/HolidayIndex.vue';
import Vue from 'vue';

Vue.component('holiday-index', HolidayIndex);

export default Vue.extend({});
